import { certificatesMapper } from '@smuchile/pkg-unimarc-components/stories/organisms/ProductCertificates/certificatesAndSeals'

type IncomingCertificate = {
  certification_type_code?: string
  certification_type_name?: string
}

export const syncProductCertificatesMapper = (
  certificates?: IncomingCertificate[]
) => {
  if (!Array.isArray(certificates)) return

  certificates.forEach((certificate) => {
    const code = certificate?.certification_type_code
    if (!code || !certificatesMapper[code]) return

    if (certificate?.certification_type_name) {
      certificatesMapper[code] = {
        ...certificatesMapper[code],
        label: certificate.certification_type_name
      }
    }
  })
}
